/*********************************************************************
 * The login form for existing users. 🐺
 * *************************************
 *
 *  @format */

import React, {useState} from 'react';

import useLogin from 'frontier/account/components/auth/ajax_login/use_login';
import ForgotPassword from '../../forgot_password/container';
import {Button, Input} from '@sttark/design-system';
import {ConditionalButton} from 'frontier/utilities';
import ErrorDisplay from 'frontier/utilities/error';
import './ajax_login.sass';

export default function CheckoutLoginContainer({
    loginButtonLabel = 'Login',
    isSavingQuote,
    redirect,
    onLogin,
    newestds
}) {
    const {
        onInputChange,
        onSubmitLogin,
        isAuthorizing,
        onKeyPress,
        isComplete,
        username,
        password,
        error
    } = useLogin({redirect, onLogin});
    const [isPasswordReset, togglePasswordReset] = useState(false);

    return (
        <div className="checkout-login">
            {error && (
                <div className="alert alert-danger">
                    <ErrorDisplay error={error} />
                </div>
            )}
            <div className="row form-group">
                <div className="col-md-6 form-group_field">
                    <Input
                        onChange={onInputChange.bind(this, 'username')}
                        placeholder="Enter your Email*"
                        onKeyUp={onKeyPress}
                        value={username}
                        name="username"
                        label={'*Email'}
                        type="text"
                    />
                </div>

                <div className="col-md-6 form-group_field">
                    <Input
                        onChange={onInputChange.bind(this, 'password')}
                        placeholder="Password*"
                        onKeyUp={onKeyPress}
                        label={'*Password'}
                        value={password}
                        type="password"
                        name="password"
                    />
                </div>
            </div>
            <div className="ajax-login__signin_buttons">
                <div className="ajax-login__custom d-flex align-items-center justify-content-start">
                    <ConditionalButton enabled={!isAuthorizing}>
                        <div className="ajax-login__login_button">
                            <Button primary label={loginButtonLabel} onClick={onSubmitLogin} />
                        </div>
                        <div className="ajax-login__login_button">
                            <Button primary label={'Authorizing...'} onClick={() => {}} disabled />
                        </div>
                    </ConditionalButton>

                    <ConditionalButton enabled={isPasswordReset}>
                        <ForgotPassword
                            onClose={togglePasswordReset.bind(this, !isPasswordReset)}
                        />
                        <button
                            className="ajax-login_login-help font-body-bold-lg p-0 text-link"
                            onClick={togglePasswordReset.bind(this, !isPasswordReset)}>
                            Login Help?
                        </button>
                    </ConditionalButton>
                </div>
            </div>
        </div>
    );
}
